/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'
import { Link } from 'react-router-dom'

import Avatar from 'react-avatar'
import { Auth0User } from '../../../types'
import { Menu } from '../../shared/menu'
import { Thumbnail } from '../../shared/media'
import { baseColor } from '../../../lib/styles/colors'
import useAppSettings from '../../../lib/hooks/useAppSettings'

type TopNavMenuProps = {
  onLogout: (logoutOptions?: any) => void
  user: Auth0User | undefined
}

const topNavMenuCss = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button {
    color: ${baseColor};
  }
`

/** IMPORTANT:  This code is duplicated in scheduler.
 * Verify any changes here are also made in scheduler.
 */
export const TopNavMenu = ({ onLogout, user }: TopNavMenuProps) => {
  const { homeSettings } = useAppSettings()
  const { signoutText } = homeSettings

  const handleLogout = async () => {
    // Keycloak at the momento does not have federated logout
    onLogout()
  }

  const menuItems = [
    {
      text: signoutText,
      disabled: false,
      onClick: handleLogout
    }
  ]
  if (!user) {
    return null
  }

  const styleAvatar = {
    fontSize: '16px',
    letterSpacing: '0.5px',
    lineHeight: '20px',
    fontFamily: 'Roboto'
  }

  const fullName =
    user && user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : ''

  return (
    <span css={topNavMenuCss}>
      <Link to="/profile">
        {user && user.picture ? (
          <Thumbnail alt="Profile" src={user?.picture} />
        ) : (
          <Avatar style={styleAvatar} size="40" round name={fullName} />
        )}
      </Link>
      <Menu
        ariaLabel="Top Navigation Menu"
        displayTooltip={false}
        icon="Arrow"
        id="gravatar-menu"
        menuItems={menuItems}
      />
    </span>
  )
}

export default TopNavMenu
